import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams, generatePath } from "react-router-dom";

// import logo from "../../assets/img/logo.png";
import Footer from "../common/Footer";
import BottomBarIcons from "../common/BottomBarIcons";
import Header from "../common/Header";
import { useSelector } from "react-redux";
import Sidebar from "../common/Sidebar";
import Toaster from "../common/Toaster";
// import QrScanner from "../components/common/Html5QrcodeScannerComponent";
import Capture from "../common/Capture";
// import MiniCapture from "./MiniCapture";
import ConfirmationPopup from "../common/ConfirmationPopup";
import BasicInformationSection from "./BasicInformationSection";
import PhyMeasurementsSection from "./PhyMeasurementsSection";
import ComplianceSection from "./ComplianceSection";
import AdditionalActionItems from "./AdditionalActionItems";

// import Loader from "./common/Loader";
import {
  GET_PROPERTY_INFO_WITH_MASTER,
  GENERATEQRCODE_API,
  SAVE_SURVEY_FORM_DATA,
  //UPLOAD_IMAGE_API,
  DELETE_IMAGE_API,
  GET_NEXT_DOOR_REF_NEW,
  GET_FLOORPLAN_IMAGE,
  GET_AI_SUGGESTION,
  SEND_FEEDBACK_TO_AI,
  PROPERTY_DASHBOARD_API,
  GET_CLIENT_COMPANY_DETAILS,
} from "../../api/apiPath";
import http from "../../api/server";
import { hostName } from "../../config/config";

import {
  COMPLIANCE_CHECK,
  FORM_DATA,
  BASE_MEASURES_SINGLE,
  BASE_MEASURES_DOUBLE,
  BASE_MEASURES_COMP,
  ACTION_MENU_FLAG,
  ACTION_MENU_IMAGES,
  AI_KEY_VALUES,
  AI_REMEDY_OPTIONS,
  Messages,
} from "../common/constant";
import LoadingComponent from "../common/LoadingComponent";
import SidebarIcons from "../common/SidebarIcons";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import dayjs from "dayjs";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useParams();
  const {
    clientNameParam,
    propertyMasterId,
    inspectionRefnumber,
    doorRefNumber,
  } = location;
  const [complianceActionIds, setComplianceActionIds] = useState({});

  //const [doorComplianceMasters, setDoorComplianceMasters] = useState([]);

  const [qrCode, setQrCode] = useState("");
  const [doorOtherFlag, setDoorOtherFlag] = useState(false);
  const [doorColorOtherFlag, setDoorColorOtherFlag] = useState(false);
  const [doorMaterialOtherFlag, setDoorMaterialOtherFlag] = useState(false);
  const [damageTypeOtherFlag, setDamageTypeOtherFlag] = useState(false);
  const [isGlazing, setIsGlazing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isColdSeals, setIsColdSeals] = useState(false);
  const [isFireKeepLocked, setFireKeepLocked] = useState(false);
  const [isHoldOpenVisible, setIsHoldopenVisible] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [complianceCheck, setComplianceCheck] = useState(COMPLIANCE_CHECK);
  const [validationFlag, setValidationFlag] = useState({
    show: false,
    message: "",
  });
  const [actionmenuFlag, setActionMenuFlag] = useState([]);
  const [actionImages, setActionImages] = useState(ACTION_MENU_IMAGES);
  const [error, setError] = useState(null);
  const [ShowScanQRCode, setShowScanQRCode] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [doorTypesOption, setDoorTypesOption] = useState([]);
  const [doorConfigurationsOption, setDoorConfigurationsOption] = useState([]);
  const [isDoubleDoor, setIsDoubleDoor] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [isFloorFromAPI, setIsFloorFromAPI] = useState(false);
  const [companyMandatoryImages, setCompanyMandatoryImages] = useState(null);
  const [floorPlanBlobUrl, setFloorPlanBlobUrl] = useState("");
  //eslint-disable-next-line no-unused-vars
  const [floorPlanPdfData, setFloorPlanPdfData] = useState("");
  const [resetCaptureFlag, setResetCaptureFlag] = useState(false);
  const [formData, setFormData] = useState(FORM_DATA);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    headingText: "",
    infoText: "",
    cancelText: "",
    submittext: "",
  });

  const [basicFormData, setBasicFormData] = useState({
    clientId: "",
    buildingName: "",
    uniqueRef: "",
    date: new Date().toISOString().split("T")[0],
    location: "",
    floor: null,
    comment: "",
    floorPlan: [],
  });
  const [aiSuggestionData, setAiSuggestionData] = useState(AI_KEY_VALUES);
  const [showAiSuggestionModal, setShowAiSuggestionModal] = useState({
    show: false,
    title: "",
    heading: "",
    desctription: "",
    severity: "",
    dueDate: "",
    remedyOptions: [],
    remediationValue: "",
    confScore: "",
    rejectReason: "",
    category: "",
  });
  const [selectedRemediation, setSelectedRemediation] =
    useState(AI_REMEDY_OPTIONS);
  const [rejectionReason, setRejectionReason] = useState(false);
  const [isAIIntegrated, setIsAIIntegrated] = useState(false);
  const [windowUrlUpdated, setWindowUrlUpdated] = useState(false);
  const [actionEntries, setActionEntries] = useState([]);

  const [actionErrors, setActionErrors] = useState([]);

  const mandatoryFieldRef = useRef({});
  const actionFieldsRef = useRef({});

  // Load property data once when the dashboard mounts.
  // The effect intentionally has an empty dependency array because
  // the initial fetch should only run on mount.
  useEffect(() => {
    setIsloading(true);
    setIsFloorFromAPI(false);

    if (propertyMasterId !== undefined && propertyMasterId !== null) {
      const fetchData = async () => {
        await fetchPropertyData();
        setTimeout(() => {
          handleFormReset();
        }, 100);
      };
      fetchData();

      let obj = ACTION_MENU_FLAG;
      // for (let key in BASE_MEASURES) {
      //   if (formData[key] < BASE_MEASURES[key]) {
      //     obj[key] = true;
      //   } else {
      //     obj[key] = false;
      //   }
      // }

      for (let key in BASE_MEASURES_COMP) {
        if (key === "pyroGlazing") {
          obj[key] = false;
        } else {
          if (complianceCheck[key] != BASE_MEASURES_COMP[key]) {
            obj[key] = true;
          } else {
            obj[key] = false;
          }
        }
      }
      setActionMenuFlag(obj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastType: "",
      toastString: "",
    });
  };

  // Fetch the current property survey details and related dashboard metadata.
  const fetchPropertyData = async () => {
    try {
      const response = await http.get(
        GET_PROPERTY_INFO_WITH_MASTER +
          propertyMasterId +
          "?InspectionReferenceNumber=" +
          inspectionRefnumber,
      );
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }

      const dataResponse = await response?.data;
      const masters = dataResponse?.doorComplainceCheckMasters ?? [];

      const map = {};
      masters.forEach((m) => {
        if (m.doorComplainceCheckMasterId && m.actionItemId) {
          map[m.doorComplainceCheckMasterId] = m.actionItemId; // ACT-100x
        }
      });

      // Enhanced logging
      setComplianceActionIds(map);

      setDoorTypesOption(dataResponse.doorTypes);
      setDoorConfigurationsOption(dataResponse?.doorConfigurations);

      //check is AI integrated in summary by client
      const summaryResponse = await http.get(
        PROPERTY_DASHBOARD_API +
          "clientId=" +
          dataResponse.propertyMaster.clientId +
          "&userId=" +
          userObj.userId,
      );
      if (!summaryResponse.status) {
        throw new Error(`HTTP error! status: ${response?.message}`);
      } else if (summaryResponse.status === 200) {
        const getProperty = summaryResponse?.data?.propertyFields.filter(
          (x) =>
            x.propertyMasterId === propertyMasterId &&
            x.inspectionReferenceNumber === inspectionRefnumber,
        );
        if (getProperty.length > 0) {
          const params = new URLSearchParams();
          params.append("propertyId", propertyMasterId);
          if (getProperty[0]?.buildingId !== null) {
            params.append("buildingId", getProperty[0]?.buildingId);
          }
          params.append("userId", userObj?.userId);
          const queryString = params.toString();
          const response1 = await http.get(
            GET_NEXT_DOOR_REF_NEW + `?${queryString}`,
          );

          let NextRefNumber = await response1?.data?.doorRefNumber;
          setBasicFormData({
            ...basicFormData,
            clientId: dataResponse.propertyMaster.clientId,
            buildingName:
              getProperty[0]?.buildingName === null
                ? dataResponse.propertyMaster.propertyName
                : getProperty[0]?.buildingName,
            buildingId: getProperty[0]?.buildingId,
            uniqueRef: dataResponse.propertyMaster.uniqueRefNo,
            location:
              getProperty[0]?.buildingName === null
                ? dataResponse.propertyMaster.propertyLocation
                : dataResponse.propertyMaster.propertyName +
                  `, ` +
                  dataResponse.propertyMaster.propertyLocation,
          });
          setFormData({
            ...formData,
            buildingName:
              getProperty[0]?.buildingName === null
                ? dataResponse.propertyMaster.propertyName
                : getProperty[0]?.buildingName,
            uniqueRef: dataResponse.propertyMaster.uniqueRefNo,
            location:
              getProperty[0]?.buildingName === null
                ? dataResponse.propertyMaster.propertyLocation
                : dataResponse.propertyMaster.propertyName +
                  `, ` +
                  dataResponse.propertyMaster.propertyLocation,
            // doorNumber:
            //   doorRefNumber === null || doorRefNumber === undefined
            //     ? await CreateDoorReference(
            //         dataResponse.propertyMaster.propertyName,
            //         NextRefNumber
            //       )
            //     : windowUrlUpdated === true
            //       ? await CreateDoorReference(
            //           dataResponse.propertyMaster.propertyName,
            //           NextRefNumber
            //         )
            //       : doorRefNumber,
            doorNumber:
              doorRefNumber === null || doorRefNumber === undefined
                ? NextRefNumber
                : windowUrlUpdated === true
                  ? NextRefNumber
                  : doorRefNumber,
          });
          setIsAIIntegrated(getProperty[0].isAIIntegrationEnabled);
        }
      }

      //check no. of mandatory images
      const companyResponse = await http.get(
        GET_CLIENT_COMPANY_DETAILS +
          "?clientId=" +
          dataResponse.propertyMaster.clientId,
      );
      if (companyResponse.status === 200) {
        const data = companyResponse?.data;
        setCompanyMandatoryImages(data?.noMandatoryImage || 4);
      }
      setIsloading(false);
      return dataResponse;
    } catch (error) {
      setCompanyMandatoryImages(4);
      setIsloading(false);
      return {};
    }
  };

  // Utility used to build a door reference string if needed.
  // Currently unused in the active flow but retained for future reference.
  //eslint-disable-next-line no-unused-vars
  const CreateDoorReference = async (propertyName, nextRefNumber) => {
    let doorRefNumber = "";
    if (propertyName != undefined && propertyName != null) {
      doorRefNumber =
        userObj?.userName
          ?.split(" ")
          ?.filter((word) => word)
          ?.map((word) => word[0].toUpperCase())
          ?.join("") +
        "-" +
        propertyName
          ?.split(" ")
          ?.filter((word) => word)
          ?.map((word) => word[0].toUpperCase())
          ?.join("") +
        "-DRN-" +
        String(nextRefNumber).padStart(4, "0");
    }
    return doorRefNumber;
  };
  const base64ToFile = (base64String, filename) => {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);

    const extensionMap = {
      jpeg: "jpeg",
      jpg: "jpg",
      png: "png",
      gif: "gif",
      webp: "webp",
      pdf: "pdf",
    };

    const mimeExt = mime.split("/")[1];
    const ext = extensionMap[mimeExt] || mimeExt;

    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    const cleanName = filename.replace(/\.[^/.]+$/, "");
    // const isIncludeExtension = filename?.includes(`.${ext}`) ? true : false;
    // return isIncludeExtension ? new File([u8arr], `${filename}`, { type: mime }) : new File([u8arr], `${filename}.${ext}`, { type: mime });
    return new File([u8arr], `${cleanName}.${ext}`, { type: mime });
  };

  // Upload a captured or selected image to the server and return its accessible URL.
  const uploadImageAPI = async (newImages, field, nameOfFile) => {
    const latestImage = newImages[newImages.length - 1];
    const file = base64ToFile(latestImage, nameOfFile);
    const formDataToUpload = new FormData();
    formDataToUpload.append("File", file);
    formDataToUpload.append("Client", basicFormData.clientId); // Use actual values from state/context if needed
    formDataToUpload.append("Property", basicFormData.buildingName);
    formDataToUpload.append("InspectionDate", new Date().toISOString());
    try {
      const response = await fetch(hostName + "/api/Inspection/upload", {
        method: "POST",
        body: formDataToUpload,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      // const response = await http.post(UPLOAD_IMAGE_API,
      //    formDataToUpload,
      //    {headers: {"Content-Type": "multipart/form-data"}})
      if (response?.status === 200) {
        const dataResponse = await response?.json();
        if (field === "Floor") {
          setFloorPlanBlobUrl(dataResponse?.result.blobUrl);
          const isFloorpdf = dataResponse?.result?.blobName.includes(".pdf")
            ? true
            : false;
          let pdfurl;
          if (isFloorpdf) {
            const blob = base64ToBlob(
              dataResponse?.result?.fileData,
              "application/pdf",
            );
            pdfurl =
              URL.createObjectURL(blob) +
              "?filename=" +
              (dataResponse?.result?.blobName || "floorplan.pdf");
            setFloorPlanPdfData(dataResponse?.result?.fileData);
          }
          return isFloorpdf ? pdfurl : dataResponse?.result?.blobUrl;
        } else {
          return dataResponse?.result.blobUrl;
        }
      } else {
        const dataResponse = await response?.json();
        const errmsg = dataResponse?.error || "Error in uploading file";
        setToastData({
          toastShow: true,
          toastString: errmsg,
          toastType: "failure",
        });
        return "";
      }
    } catch (error) {
      const errmsg = error?.data?.error || "Error in uploading file";
      setToastData({
        toastShow: true,
        toastString: errmsg,
        toastType: "failure",
      });
      return "";
    }
  };

  // Delete an image from the backend by URL or identifier.
  const deleteImageAPI = async (imageToDelete) => {
    try {
      if (
        imageToDelete != null &&
        imageToDelete.trim() !== ""
      ) {
        const response = await http.delete(DELETE_IMAGE_API + imageToDelete);
        if (!response.status) {
          setToastData({
            toastShow: true,
            toastString: "Error in deleting file",
            toastType: "failure",
          });
        } else {
          setToastData({
            toastShow: true,
            toastString: "File deleted successfully",
            toastType: "success",
          });
        }
      }
    } catch (error) {
      // setError(error?.data);
      setToastData({
        toastShow: true,
        toastString: "Error in deleting file",
        toastType: "failure",
      });
    }
  };
  const handleDeleteImages = (indexToRemove, field) => {
    let imageToDelete = "";
    if (field === "Additional") {
      imageToDelete = floorPlanImages[indexToRemove];
      const combined = floorPlanImages?.filter(
        (_, index) => index !== indexToRemove,
      );
      setFloorPlanImages(combined); // No limit now
    } else if (field === "Door") {
      mandatoryFieldRef.current.doorFile.value = "";
      imageToDelete = formData.doorPhotos[indexToRemove];
      const imgArr = formData.doorPhotos;
      const combined = imgArr?.filter((_, index) => index !== indexToRemove);
      setFormData({
        ...formData,
        doorPhotos: combined,
      });
      resetIndvidualField("doorFile");
    } else if (field === "Floor") {
      mandatoryFieldRef.current.floorFile.value = "";
      //imageToDelete = basicFormData.floorPlan[indexToRemove];
      imageToDelete = floorPlanBlobUrl;
      const imgArr = basicFormData.floorPlan;
      const combined = imgArr?.filter((_, index) => index !== indexToRemove);
      setBasicFormData({
        ...basicFormData,
        floorPlan: combined,
      });
      resetIndvidualField("floorFile");
    } else {
      const imgArr = actionImages[field];
      imageToDelete = imgArr[indexToRemove];
      const combined = imgArr?.filter((_, index) => index !== indexToRemove);
      setActionImages({
        ...actionImages,
        [field]: combined,
      });
    }
    if (field === "Floor") {
      if (!isFloorFromAPI) {
        //   deleteImageAPI(imageToDelete);
      }
      // deleteImageAPI(imageToDelete);
    } else {
      deleteImageAPI(imageToDelete);
    }
  };

  // Handle toggling compliance checklist fields and update action menu state.
  const handleComplianceToggle = (e) => {
    if (e.target.name === "selfClosingDevice") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          selfClosingDevice: e.target.checked,
        };
      });
      setFireKeepLocked(!e.target.checked);
    } else if (e.target.name === "fireLockedSign") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          fireLockedSign: e.target.checked,
        };
      });
      setActionMenuFlag({
        ...actionmenuFlag,
        fireLockedSign: !e.target.checked,
      });
      if (e.target.checked === false) {
        getAiSuggestion("COMPLIANCE", "fireLockedSign", "no");
      }
    } else if (e.target.name === "fireShutSign") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          fireShutSign: e.target.checked,
        };
      });
      setActionMenuFlag({
        ...actionmenuFlag,
        fireShutSign: !e.target.checked,
      });
      if (e.target.checked === false) {
        getAiSuggestion("COMPLIANCE", "fireShutSign", "no");
      }
      setIsHoldopenVisible(!e.target.checked);
    } else {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          [e.target.name]: e.target.checked,
        };
      });
      if (
        BASE_MEASURES_COMP[e.target.name] != undefined &&
        e.target.checked != BASE_MEASURES_COMP[e.target.name]
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
        if (
          e.target.name != "damageToDoor" &&
          e.target.name != "visualDefectsToDoor" &&
          e.target.name != "doorFitWithinFrame" &&
          e.target.name != "damageToFrame"
        ) {
          getAiSuggestion("COMPLIANCE", e.target.name, "no");
        }
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    }

    // if (e.target.name === "doorGlazing") {
    //   if (e.target.checked === true) {
    //     setIsGlazing(true);
    //     if (complianceCheck.pyroGlazing != BASE_MEASURES_COMP.pyroGlazing) {
    //       setActionMenuFlag({
    //         ...actionmenuFlag,
    //         pyroGlazing: true,
    //       });
    //     } else {
    //       setActionMenuFlag({
    //         ...actionmenuFlag,
    //         pyroGlazing: false,
    //       });
    //     }
    //   } else {
    //     setIsGlazing(false);
    //     setActionMenuFlag({
    //       ...actionmenuFlag,
    //       pyroGlazing: false,
    //     });
    //   }
    // }
  };

  const resetIndvidualField = (field) => {
    if (field === "glazingDoorLabel") {
      const glazingArr = [
        "glazingDoorLabel0",
        "glazingDoorLabel1",
        "glazingDoorLabel2",
        "glazingDoorLabel3",
      ];
      glazingArr.forEach((elem) => {
        mandatoryFieldRef.current[elem].style.border = "2px solid #ccc";
      });
    } else {
      mandatoryFieldRef.current[field] != null
        ? (mandatoryFieldRef.current[field].style.border = "1px solid #dee2e6")
        : null;
    }
  };

  const resetMandatoryFields = () => {
    let newArr = [];
    if (doorOtherFlag) {
      newArr = [
        "floor",
        "doorLocation",
        "doorConfiguration",
        "doorType",
        "doorOther",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "hingeLocation",
        "noOfhinges",
        "closing",
        "doorThickness",
        "frameDepth",
        "doorHeight",
        "doorWidth",
        "fullDoorsetSize",
        // "floorFile",
        "doorFile",
        "fireResistance",
        // "hingesFireRatedRating",
        "doorFitWithinFrame",
        "damageToFrame",
      ];
    } else {
      newArr = [
        "floor",
        "doorLocation",
        "doorConfiguration",
        "doorType",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "hingeLocation",
        "noOfHinges",
        "closing",
        "doorThickness",
        "frameDepth",
        "doorHeight",
        "doorWidth",
        "fullDoorsetSize",
        // "floorFile",
        "doorFile",
        "fireResistance",
        // "hingesFireRatedRating",
        "doorFitWithinFrame",
        "damageToFrame",
      ];
    }
    if (doorColorOtherFlag) {
      newArr = [...newArr, "doorColorOther"];
    }
    if (doorMaterialOtherFlag) {
      newArr = [...newArr, "doorMaterialOther"];
    }
    if (isDoubleDoor) {
      newArr = [
        ...newArr,
        "leftHead",
        "rightHead",
        "leftHinge",
        "rightHinge",
        "leftThreshold",
        "rightThreshold",
      ];
    } else {
      newArr = [...newArr, "hinge", "head", "threshold"];
    }
    newArr.forEach((elem) => {
      mandatoryFieldRef?.current[elem] != null
        ? (mandatoryFieldRef.current[elem].style.border = "1px solid #dee2e6")
        : null;
    });

    // mandatoryFieldRef?.current?.floorFile != null
    //   ? (mandatoryFieldRef.current.floorFile.style.border = "1px solid #dee2e6")
    //   : null;
    mandatoryFieldRef?.current?.doorFile != null
      ? (mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6")
      : null;
  };

  const handleMandatoryFields = () => {
    let newArr = [];
    if (doorOtherFlag) {
      newArr = [
        "floor",
        "doorLocation",
        "doorType",
        "doorConfiguration",
        "doorOther",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "hingeLocation",
        "noOfHinges",
        "closing",
        "doorThickness",
        "frameDepth",
        "doorHeight",
        "doorWidth",
        "fullDoorsetSize",
        "fireResistance",
      ];
    } else {
      newArr = [
        "floor",
        "doorLocation",
        "doorType",
        "doorColor",
        "doorConfiguration",
        "doorMaterial",
        "GlazingDoor",
        "hingeLocation",
        "noOfHinges",
        "closing",
        "doorThickness",
        "frameDepth",
        "doorHeight",
        "doorWidth",
        "fullDoorsetSize",
        "fireResistance",
      ];
    }
    if (doorColorOtherFlag) {
      newArr = [...newArr, "doorColorOther"];
    }
    if (doorMaterialOtherFlag) {
      newArr = [...newArr, "doorMaterialOther"];
    }
    if (isDoubleDoor) {
      newArr = [
        ...newArr,
        "leftHead",
        "rightHead",
        "leftHinge",
        "rightHinge",
        "leftThreshold",
        "rightThreshold",
      ];
    } else {
      newArr = [...newArr, "hinge", "head", "threshold"];
    }
    newArr.forEach((elem) => {
      const test = mandatoryFieldRef?.current[elem];
      if (
        test != undefined &&
        (!test?.value?.trim() || test?.value === "Select")
      ) {
        mandatoryFieldRef.current[elem].style.border = "2px solid red";
      } else {
        mandatoryFieldRef.current[elem].style.border = "1px solid #dee2e6";
      }
      if (elem === "noOfHinges") {
        test?.value <= 0
          ? (mandatoryFieldRef.current[elem].style.border = "2px solid red")
          : (mandatoryFieldRef.current[elem].style.border =
              "1px solid #dee2e6");
      }
    });
    for (let key in ACTION_MENU_FLAG) {
      if (actionmenuFlag[key] === true) {
        const tempArr = [
          "Severity",
          "Category",
          "DueDate",
          "Remediation",
          "DamageType",
        ];
        tempArr.forEach((elem) => {
          const test = mandatoryFieldRef?.current[key + elem];
          if (test != undefined) {
            if (!test?.value.trim() || test?.value === "Select") {
              mandatoryFieldRef.current[key + elem].style.border =
                "2px solid red";
            } else {
              mandatoryFieldRef.current[key + elem].style.border =
                "1px solid #dee2e6";
            }
          }
        });
      }
      if (key === "visualDefectsToDoor" && actionmenuFlag[key] === true) {
        let tempArr = [
          "Severity",
          "Category",
          "DueDate",
          "Remediation",
          "DamageType",
        ];
        if (damageTypeOtherFlag) {
          tempArr = [...tempArr, "DamageTypeOther"];
        }
        tempArr.forEach((elem) => {
          const test = mandatoryFieldRef?.current[key + elem];
          if (test != undefined) {
            if (!test?.value.trim() || test?.value === "Select") {
              mandatoryFieldRef.current[key + elem].style.border =
                "2px solid red";
            } else {
              mandatoryFieldRef.current[key + elem].style.border =
                "1px solid #dee2e6";
            }
          }
        });
      }
    }
    const glazingArr = [
      "glazingDoorLabel0",
      "glazingDoorLabel1",
      "glazingDoorLabel2",
      "glazingDoorLabel3",
    ];
    if (mandatoryFieldRef.current.GlazingDoor?.value === "Yes") {
      if (formData.glazingDoorLabel === "") {
        glazingArr.forEach((elem) => {
          mandatoryFieldRef.current[elem].style.border = "2px solid red";
        });
      } else {
        glazingArr.forEach((elem) => {
          mandatoryFieldRef.current[elem].style.border = "2px solid #ccc";
        });
      }
    }
    if (
      mandatoryFieldRef?.current?.doorFile != undefined ||
      mandatoryFieldRef.current.doorFile != null
    ) {
      if (formData.doorPhotos.length === 0) {
        mandatoryFieldRef.current.doorFile.style.border = "2px solid red";
      } else {
        mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
      }
    }
  };

  const handleValidationOnSave = (status) => {
    setIsloading(true);
    let validFlag1 = false;
    let validFlag2 = false;
    let validFlag3 = false;
    let validFlag4 = false;
    let baseMeasuresPhysical;
    if (isDoubleDoor) {
      baseMeasuresPhysical = BASE_MEASURES_DOUBLE;
    } else {
      baseMeasuresPhysical = BASE_MEASURES_SINGLE;
    }
    for (let key in baseMeasuresPhysical) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined
      ) {
        validFlag1 = true;
        break;
      } else if (
        actionmenuFlag[key] === true &&
        (formData[key + "Severity"] === "Select" ||
          formData[key + "Category"] === "Select" ||
          formData[key + "Remediation"] === "" ||
          formData[key + "DueDate"] === "" ||
          actionImages[key].length === 0)
      ) {
        validFlag1 = true;
        break;
      } else if (key === "hinge" && formData.hingeLocation === "Select") {
        validFlag1 = true;
        break;
      } else if (key === "noOfHinges" && formData[key] <= 0) {
        validFlag1 = true;
        break;
      } else {
        validFlag1 = false;
      }
    }
    let checkArr = { doorType: "doorType", doorPhotos: "doorPhotos" };
    for (let key in checkArr) {
      if (key === "doorPhotos" && formData[key].length === 0) {
        validFlag2 = true;
        break;
      } else if (key === "doorType") {
        if (
          formData[key] === "4" &&
          (formData.doorOther === "" ||
            formData.doorOther === null ||
            formData.doorOther === undefined)
        ) {
          validFlag2 = true;
          break;
        } else if (formData[key] === "Select") {
          validFlag2 = true;
          break;
        }
      } else {
        validFlag2 = false;
      }
    }
    for (let key in BASE_MEASURES_COMP) {
      if (key === "pyroGlazing" && complianceCheck.doorGlazing === true) {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            actionImages[key].length === 0)
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
      } else if (key === "coldSmokeSeals") {
        if (isColdSeals) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "" ||
              actionImages[key].length === 0)
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "fireLockedSign") {
        if (isFireKeepLocked) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "" ||
              actionImages[key].length === 0)
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "holdOpenDevice") {
        if (isHoldOpenVisible) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "" ||
              actionImages[key].length === 0)
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "visualDefectsToDoor") {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            complianceCheck[key + "DamageType"] === "Select" ||
            actionImages[key].length === 0)
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
        if (
          actionmenuFlag[key] === true &&
          complianceCheck[key + "DamageType"] === "Other" &&
          (complianceCheck[key + "DamageTypeOther"] === "" ||
            complianceCheck[key + "DamageTypeOther"] === undefined)
        ) {
          validFlag3 = true;
          break;
        }
      } else if (key === "hingeFireRated") {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            actionImages[key].length === 0)
        ) {
          validFlag3 = true;
          break;
        }
        // else if (
        //   actionmenuFlag[key] === false &&
        //   complianceCheck[key + "Rating"] === "Select"
        // ) {
        //   validFlag3 = true;
        //   break;
        // }
        else {
          validFlag3 = false;
        }
      } else {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            actionImages[key].length === 0)
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
      }
    }
    let phyArr = {
      doorThickness: null,
      frameDepth: null,
      doorHeight: null,
      doorWidth: null,
      fullDoorsetSize: null,
    };
    for (let key in phyArr) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined
      ) {
        validFlag4 = true;
        break;
      } else {
        validFlag4 = false;
      }
    }
    let validFlag5 = false;
    if (
      // basicFormData.floorPlan.length === 0 ||
      basicFormData.floor === undefined ||
      basicFormData.floor === null ||
      basicFormData.floor === "" ||
      formData.fireResistance === "Select"
    ) {
      validFlag5 = true;
    } else {
      validFlag5 = false;
    }
    //check door location
    let validFlag6;
    if (
      formData.doorLocation === "" ||
      formData.doorLocation === undefined ||
      formData.doorLocation === null
    ) {
      validFlag6 = true;
    } else {
      validFlag6 = false;
    }
    let validFlag7;
    let doorArr = {
      doorType: null,
      doorTypeName: null,
      doorColor: null,
      doorConfigurationName: null,
      doorConfiguration: null,
      // doorOther: null,
      // doorColorOther: null,
      doorMaterial: null,
      // doorMaterialOther: null,
      GlazingDoor: null,
      // glazingDoorLabel: null,
      fireResistance: null,
    };
    if (doorOtherFlag) {
      doorArr.doorOther = null;
    }
    if (doorColorOtherFlag) {
      doorArr.doorColorOther = null;
    }
    if (doorMaterialOtherFlag) {
      doorArr.doorMaterialOther = null;
    }
    if (formData.GlazingDoor === "Yes") {
      doorArr.glazingDoorLabel = null;
    }
    for (let key in doorArr) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined ||
        formData[key] === "Select"
      ) {
        validFlag7 = true;
        break;
      } else {
        validFlag7 = false;
      }
    }
    // let validFlag8;
    // if (
    //   actionmenuFlag.hingesFireRated === false &&
    //   (complianceCheck.hingesFireRatedRating === "Select" ||
    //     complianceCheck.hingesFireRatedRating === null ||
    //     complianceCheck.hingesFireRatedRating === "")
    // ) {
    //   validFlag8 = true;
    // } else {
    //   validFlag8 = false;
    // }

    let validFlag9 = false;
    if (actionEntries && actionEntries.length > 0) {
      const allErrors = actionEntries.map(validateActionEntry);
      const hasAnyError = allErrors.some((e) => Object.keys(e).length > 0);
      setActionErrors(allErrors);
      validFlag9 = hasAnyError;
    }

    let validFlag10;
    if (companyMandatoryImages) {
      // let allImages = Object.values(actionImages).flat();
      const allImages = [...floorPlanImages, ...formData.doorPhotos];
      // if(actionEntries && actionEntries.length > 0){
      //   const actionImages = actionEntries.flatMap(obj => obj.actionFile);
      //   allImages = [...allImages, ...actionImages]
      // }
      if (allImages.length < companyMandatoryImages) {
        validFlag10 = true;
      } else {
        validFlag10 = false;
      }
    }

    if (
      validFlag1 ||
      validFlag2 ||
      validFlag3 ||
      validFlag4 ||
      validFlag5 ||
      validFlag6 ||
      validFlag7 ||
      // validFlag8 ||
      validFlag9 ||
      validFlag10
    ) {
      setValidationFlag({
        show: true,
        message: validFlag10
          ? `Upload at least ${Number(companyMandatoryImages) - 1} additional images.`
          : "Plesae fill all required fields.",
      });
      handleMandatoryFields();
      setIsloading(false);
    } else {
      setValidationFlag({ show: false, message: "" });
      handleSubmit(status);
    }
  };

  const highlightActionField = (field) => {
    actionFieldsRef.current[field] != null
      ? (actionFieldsRef.current[field].style.border = "2px solid red")
      : null;
  };

  const validateActionEntry = (entry, index) => {
    const DEFAULT_SELECT = "Select";
    const errors = {};

    if (!entry.actionLabel || !entry.actionLabel.trim()) {
      errors.actionLabel = "Action label is required.";
      highlightActionField("actionLabel" + index);
    }

    if (!entry.actionValue || !entry.actionValue.trim()) {
      errors.actionValue = "Action value is required.";
      highlightActionField("actionValue" + index);
    }

    if (!entry.actionSeverity || entry.actionSeverity === DEFAULT_SELECT) {
      errors.actionSeverity = "Please select a severity.";
      highlightActionField("actionSeverity" + index);
    }

    if (!entry.actionCategory || entry.actionCategory === DEFAULT_SELECT) {
      errors.actionCategory = "Please select a category.";
      highlightActionField("actionCategory" + index);
    }

    // Date validation (YYYY-MM-DD)
    if (!entry.actionDueDate) {
      errors.actionDueDate = "Due date is required.";
      highlightActionField("actionDueDate" + index);
    }

    if (!entry.actionRemediation) {
      errors.actionRemediation = "remediation is required";
      highlightActionField("actionRemediation" + index);
    }

    // Files optional; example size/count rule if needed:
    if (Array.isArray(entry.actionFile) && entry.actionFile.length === 0) {
      errors.actionFile = "at least 1 file required";
    }

    return errors;
  };

  const handleSubmit = async (status) => {
    //Create payload for API

    let phyGaps;
    if (isDoubleDoor) {
      phyGaps = [
        "noOfHinges",
        "closing",
        "leftHead",
        "rightHead",
        "leftHinge",
        "rightHinge",
        "leftThreshold",
        "rightThreshold",
      ];
    } else {
      phyGaps = ["head", "hinge", "noOfHinges", "closing", "threshold"];
    }
    let newObj = {
      fireRatingID: formData.fireResistance ? formData.fireResistance : "",
      comments: basicFormData.comment ? basicFormData.comment : "",
      hingePosition: formData.hingeLocation,
    };
    phyGaps.forEach((elem) => {
      let newObj1 = {
        value: Number(formData[elem]),
        actionItem: actionmenuFlag[elem] ? "yes" : "no",
        timeline: "Short term",
        severity: actionmenuFlag[elem]
          ? formData[elem + "Severity"]
            ? formData[elem + "Severity"]
            : ""
          : "",
        comment: actionmenuFlag[elem]
          ? formData[elem + "Comments"]
            ? formData[elem + "Comments"]
            : ""
          : "",
        category: actionmenuFlag[elem]
          ? formData[elem + "Category"]
            ? formData[elem + "Category"]
            : ""
          : "",
        dueDate: actionmenuFlag[elem]
          ? formData[elem + "DueDate"]
            ? formData[elem + "DueDate"]
            : null
          : null,
        remediation: actionmenuFlag[elem]
          ? formData[elem + "Remediation"]
            ? formData[elem + "Remediation"]
            : ""
          : "",
        photos: actionmenuFlag[elem] ? actionImages[elem] : [],
        status: "",
        completedBy: "",
        completedOn: null,
        additionalComments: "",
        ActionItemAssignedTo: null,
      };
      newObj[elem] = newObj1;
    });
    const phyMeasures = [
      "doorThickness",
      "frameDepth",
      "doorHeight",
      "doorWidth",
      "fullDoorsetSize",
    ];
    phyMeasures.forEach((elem) => {
      let newObj1 = {
        value: Number(formData[elem]),
        actionItem: "no",
        timeline: "",
        severity: "",
        comment: "",
        category: "",
        dueDate: null,
        remediation: "",
        photos: [],
        status: "",
        completedBy: "",
        completedOn: null,
        additionalComments: "",
        ActionItemAssignedTo: null,
      };
      newObj[elem] = newObj1;
    });

    //save null for hidden gaps
    let phyHidden;

    if (isDoubleDoor) {
      phyHidden = ["head", "hinge", "threshold"];
    } else {
      phyHidden = [
        "lefHhead",
        "rightHead",
        "leftHinge",
        "rightHinge",
        "leftThreshold",
        "rightThreshold",
      ];
    }
    phyHidden.forEach((elem) => {
      let newObj1 = {
        value: 0,
        actionItem: "no",
        timeline: "",
        severity: "",
        comment: "",
        category: "",
        dueDate: null,
        remediation: "",
        photos: [],
        status: "",
        completedBy: "",
        completedOn: null,
        additionalComments: "",
        ActionItemAssignedTo: null,
      };
      newObj[elem] = newObj1;
    });

    let customCompliance = [];

    if (actionEntries && actionEntries.length > 0) {
      const PREFIX = "CUST-";
      const START_NUM = 1001;

      actionEntries.map((entry, index) => {
        let tempObj = {
          customLabel: entry.actionLabel,
          customValue: entry.actionValue.toString(),
          actionId: `${PREFIX}${START_NUM + index}`,
          actionItem: "yes",
          timeline: "",
          severity: entry.actionSeverity,
          category: entry.actionCategory,
          remediation: entry.actionRemediation,
          dueDate: entry.actionDueDate,
          photos: entry.actionFile,
          status: "",
          completedBy: "",
          completedOn: null,
          additionalComments: "",
          ActionItemAssignedTo: null,
        };
        customCompliance.push(tempObj);
      });
    }

    newObj["customComplianceActionJson"] = customCompliance;

    const compArr = [
      "intumescentStrips",
      "coldSmokeSeals",
      "selfClosingDevice",
      "fireLockedSign",
      "fireShutSign",
      "holdOpenDevice",
      "visibleCertification",
      "doorGlazing",
      "pyroGlazing",
      "doorCloseFully",
      "damageToDoor",
      "visualDefectsToDoor",
      "hingesFireRated",
      "doorFitWithinFrame",
      "damageToFrame",
    ];
    let newArr = [];
    // Prepare common fields for all compliance checks (calculate once outside loop)
    // const currentTimestamp = new Date().toISOString();
    const currentTimestamp = null;
    // const completedBy = userObj?.userEmail || "";
    const completedBy = "";

    compArr.forEach((item) => {
      const masterId = complianceCheck[item + "Id"] || "";
      // Get actionId from map using masterId as key - similar to how complianceCheckMasterID is set
      // Try both string and original format to handle any type mismatches
      let actionId = "";
      if (masterId) {
        actionId =
          complianceActionIds[masterId] ||
          complianceActionIds[String(masterId)] ||
          "";
      }

      // Determine status based on compliance
      // const complianceStatus = complianceCheck[item] ? "Compliant" : "Non-Compliant";

      const complianceStatus = "";

      // Enhanced console logging - using window.console to ensure it shows
      if (item === "fireLockedSign") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          ActionItemAssignedTo: null,
          isCompliant: complianceCheck[item],
          actionItem: !isFireKeepLocked
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : complianceCheck[item]
              ? {
                  timeline: "",
                  severity: "",
                  comment: "",
                  category: "",
                  dueDate: null,
                  remediation: "",
                  photos: [],
                  damageType: "",
                  fireRating: "",
                }
              : {
                  timeline: "Short term",
                  severity: complianceCheck[item + "Severity"]
                    ? complianceCheck[item + "Severity"]
                    : "",
                  comment: complianceCheck[item + "Comments"]
                    ? complianceCheck[item + "Comments"]
                    : "",
                  category: complianceCheck[item + "Category"]
                    ? complianceCheck[item + "Category"]
                    : "",
                  dueDate: complianceCheck[item + "DueDate"]
                    ? complianceCheck[item + "DueDate"]
                    : null,
                  remediation: complianceCheck[item + "Remediation"]
                    ? complianceCheck[item + "Remediation"]
                    : "",
                  photos: actionImages[item],
                  damageType: "",
                  fireRating: "",
                },
        };
        // Ensure actionId is always present
        if (!Object.prototype.hasOwnProperty.call(newObj2, "actionId")) {
          newObj2.actionId = actionId;
        }
        newArr.push(newObj2);
      } else if (item === "holdOpenDevice") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          ActionItemAssignedTo: null,
          isCompliant: complianceCheck[item],
          actionItem: !isHoldOpenVisible
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : complianceCheck[item]
              ? {
                  timeline: "",
                  severity: "",
                  comment: "",
                  category: "",
                  dueDate: null,
                  remediation: "",
                  photos: [],
                  damageType: "",
                  fireRating: "",
                }
              : {
                  timeline: "Short term",
                  severity: complianceCheck[item + "Severity"]
                    ? complianceCheck[item + "Severity"]
                    : "",
                  comment: complianceCheck[item + "Comments"]
                    ? complianceCheck[item + "Comments"]
                    : "",
                  category: complianceCheck[item + "Category"]
                    ? complianceCheck[item + "Category"]
                    : "",
                  dueDate: complianceCheck[item + "DueDate"]
                    ? complianceCheck[item + "DueDate"]
                    : null,
                  remediation: complianceCheck[item + "Remediation"]
                    ? complianceCheck[item + "Remediation"]
                    : "",
                  photos: actionImages[item],
                  damageType: "",
                  fireRating: "",
                },
        };
        // Ensure actionId is always present
        if (!Object.prototype.hasOwnProperty.call(newObj2, "actionId")) {
          newObj2.actionId = actionId;
        }
        newArr.push(newObj2);
      } else if (item === "pyroGlazing") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          ActionItemAssignedTo: null,
          isCompliant: complianceCheck[item],
          actionItem: !isGlazing
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : complianceCheck[item]
              ? {
                  timeline: "",
                  severity: "",
                  comment: "",
                  category: "",
                  dueDate: null,
                  remediation: "",
                  photos: [],
                  damageType: "",
                  fireRating: "",
                }
              : {
                  timeline: "Short term",
                  severity: complianceCheck[item + "Severity"]
                    ? complianceCheck[item + "Severity"]
                    : "",
                  comment: complianceCheck[item + "Comments"]
                    ? complianceCheck[item + "Comments"]
                    : "",
                  category: complianceCheck[item + "Category"]
                    ? complianceCheck[item + "Category"]
                    : "",
                  dueDate: complianceCheck[item + "DueDate"]
                    ? complianceCheck[item + "DueDate"]
                    : null,
                  remediation: complianceCheck[item + "Remediation"]
                    ? complianceCheck[item + "Remediation"]
                    : "",
                  photos: actionImages[item],
                  damageType: "",
                  fireRating: "",
                },
        };
        newArr.push(newObj2);
      } else if (
        item === "damageToDoor" ||
        item === "visualDefectsToDoor" ||
        item === "damageToFrame"
      ) {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          ActionItemAssignedTo: null,
          isCompliant: complianceCheck[item],
          actionItem: !complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : {
                timeline: "Short term",
                severity: complianceCheck[item + "Severity"]
                  ? complianceCheck[item + "Severity"]
                  : "",
                comment: complianceCheck[item + "Comments"]
                  ? complianceCheck[item + "Comments"]
                  : "",
                category: complianceCheck[item + "Category"]
                  ? complianceCheck[item + "Category"]
                  : "",
                dueDate: complianceCheck[item + "DueDate"]
                  ? complianceCheck[item + "DueDate"]
                  : null,
                remediation: complianceCheck[item + "Remediation"]
                  ? complianceCheck[item + "Remediation"]
                  : "",
                photos: actionImages[item],
                damageType:
                  item === "visualDefectsToDoor"
                    ? damageTypeOtherFlag
                      ? `${complianceCheck[item + "DamageType"]}-${complianceCheck[item + "DamageTypeOther"]}`
                      : complianceCheck[item + "DamageType"]
                    : "",
                fireRating: "",
              },
        };
        // Ensure actionId is always present
        if (!Object.prototype.hasOwnProperty.call(newObj2, "actionId")) {
          newObj2.actionId = actionId;
        }
        newArr.push(newObj2);
      } else {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          ActionItemAssignedTo: null,
          isCompliant: complianceCheck[item],
          actionItem: complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating:
                  item === "hingesFireRated"
                    ? complianceCheck[item + "Rating"]
                    : "",
              }
            : {
                timeline: "Short term",
                severity: complianceCheck[item + "Severity"]
                  ? complianceCheck[item + "Severity"]
                  : "",
                comment: complianceCheck[item + "Comments"]
                  ? complianceCheck[item + "Comments"]
                  : "",
                category: complianceCheck[item + "Category"]
                  ? complianceCheck[item + "Category"]
                  : "",
                dueDate: complianceCheck[item + "DueDate"]
                  ? complianceCheck[item + "DueDate"]
                  : null,
                remediation: complianceCheck[item + "Remediation"]
                  ? complianceCheck[item + "Remediation"]
                  : "",
                photos: actionImages[item],
                damageType:
                  item === "visualDefectsToDoor"
                    ? damageTypeOtherFlag
                      ? `${complianceCheck[item + "DamageType"]}-${complianceCheck[item + "DamageTypeOther"]}`
                      : complianceCheck[item + "DamageType"]
                    : "",
                fireRating: "",
              },
        };
        // Ensure actionId is always present
        if (!Object.prototype.hasOwnProperty.call(newObj2, "actionId")) {
          newObj2.actionId = actionId;
        }
        newArr.push(newObj2);
      }
    });

    let doorImgObj = {};
    for (let key = 1; key <= formData.doorPhotos.length; key++) {
      let name = "Image " + key + " Path";
      doorImgObj[name] = formData.doorPhotos[key - 1];
    }

    if (propertyMasterId !== undefined && propertyMasterId !== null) {
      const fullFormData = {
        propertyInfo: {
          propertyMasterId: propertyMasterId,
          buildingId: basicFormData.buildingId,
          inspectionReferenceNumber: inspectionRefnumber,
          inspectionStartedOn: basicFormData.date,
          inspectedBy: userObj.userEmail,
          inspectedById: userObj.userId,
          inspectionApprovedDate: null,
          lastInspectionDate: new Date().toISOString(),
          inspectionApprovedBy: "",
          lastInspectedBy: userObj.userEmail,
          status: status,
          inspectionUpdatedBy: userObj.userEmail,
          inspectionUpdatedOn: new Date().toISOString(),
          nextInspectionDueDate: null,
          isAdmin: userObj?.isAdmin,
        },
        inspectedPropertyFloorsInfo: {
          floorNo:
            basicFormData.floor != undefined
              ? Number(basicFormData.floor)
              : null,
          floorPlanImage: floorPlanBlobUrl, //floorPlanPdfData !== "" ? floorPlanPdfData + "&blobUrl=" + floorPlanBlobUrl : floorPlanBlobUrl,
          createdBy: userObj?.userEmail,
          updatedBy: userObj?.userEmail,
        },
        inspectedDoorDto: {
          floorNo:
            basicFormData.floor != undefined
              ? Number(basicFormData.floor)
              : null,
          floorImage: floorPlanBlobUrl, //floorPlanPdfData !== "" ? floorPlanPdfData + "&blobUrl=" + floorPlanBlobUrl : floorPlanBlobUrl,
          doorTypeId: formData.doorType ? formData.doorType : "",
          doorRefNumber: formData.doorNumber ? formData.doorNumber : "",
          doorNumber: formData.doorNumber ? formData.doorNumber : "",
          inspectedBy: userObj.userEmail,
          doorInspectionDate: basicFormData.date,
          status: "Compliant",
          flatName: "Flat A",
          doorTypeName: formData.doorTypeName ? formData.doorTypeName : "",
          propertyName: basicFormData.buildingName
            ? basicFormData.buildingName
            : "",
          otherDoorTypeName: formData.doorOther,
          doorLocation: formData.doorLocation,
          doorPhoto: doorImgObj,
          doorColor: doorColorOtherFlag
            ? formData.doorColor + "-" + formData.doorColorOther
            : formData.doorColor,
          doorMaterial: doorMaterialOtherFlag
            ? formData.doorMaterial + "-" + formData.doorMaterialOther
            : formData.doorMaterial,
          doorGlaze:
            formData.GlazingDoor === "Yes" ? formData.glazingDoorLabel : "No",
          doorConfigurationId: formData.doorConfiguration,
        },
        complianceChecks: newArr,
        physicalMeasurement: newObj,
        additionalInfos: [
          {
            imagePath: floorPlanImages,
          },
        ],
      };

      // CRITICAL: Verify actionId is in every compliance check
      const missingActionIds = newArr.filter(
        (item) => !Object.prototype.hasOwnProperty.call(item, "actionId"),
      );
      if (missingActionIds.length > 0) {
        // Fix them
        missingActionIds.forEach((item) => {
          const masterId = item.complianceCheckMasterID;
          item.actionId = masterId
            ? complianceActionIds[masterId] ||
              complianceActionIds[String(masterId)] ||
              ""
            : "";
        });
      }

      // FINAL VERIFICATION: Ensure all required fields are present before sending
      fullFormData.complianceChecks = fullFormData.complianceChecks.map(
        (item) => {
          // Ensure all required API fields are present
          return {
            ...item,
            actionId: item.actionId !== undefined ? item.actionId : "",
            status:
              item.status !== undefined
                ? item.status
                : item.isCompliant
                  ? "Compliant"
                  : "Non-Compliant",
            completedBy:
              item.completedBy !== undefined ? item.completedBy : completedBy,
            completedOn:
              item.completedOn !== undefined
                ? item.completedOn
                : currentTimestamp,
            additionalComments:
              item.additionalComments !== undefined
                ? item.additionalComments
                : "",
          };
        },
      );

      const response = await saveData(JSON.stringify(fullFormData));
      if (response.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString:
            "Your inspection for Door reference Number: " +
            formData.doorNumber +
            " has been saved successfully.",
        });
        setTimeout(() => loadNewForm(), 3000);
      } else {
        setIsloading(false);
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in saving data, please try again",
        });
      }
    }
  };

  const saveData = async (allData) => {
    try {
      const response = await http.post(SAVE_SURVEY_FORM_DATA, allData);
      return response;
    } catch (error) {
      return error;
    }
  };

  const loadNewForm = async () => {
    setIsloading(true);
    if (doorRefNumber != null || doorRefNumber != undefined) {
      const url = new URL(window.location.href);
      const segments = url.toString().split("/");
      const filtered = segments.filter((seg) => !seg.includes("DRN"));
      const cleanedUrl = filtered.join("/");
      setWindowUrlUpdated(true);
      // window.history.replaceState(null, "", cleanedUrl);
      window.location.href = cleanedUrl;
    }

    await fetchPropertyData();

    handleFormReset();
    setTimeout(
      () =>
        setToastData({
          toastShow: true,
          toastString:
            "Survey is now refreshed for new door. Please continue for new next door.",
          toastType: "success",
        }),
      500,
    );
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; }
            .print-container { text-align: center; }
            .modal-header { background-color: gray; color: white; padding: 10px; }
          </style>
        </head>
        <body>
          <div class="print-container" style="margin-top:100px">
            <img src="${qrCode}" alt="QR Code" height='400px' width='400px' />
            <h3>Door Reference Number: ${formData.doorNumber}</h3>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };
  const handleBuildingName = (e) => {
    setFormData({ ...formData, buildingName: e.target.value });
  };
  const handleFormDataChange = (e) => {
    resetIndvidualField(e.target.name);
    if (e.target.name === "doorType") {
      const doorTypeName = e.target.options[e.target.selectedIndex].text;
      setFormData({
        ...formData,
        doorTypeName: doorTypeName,
        [e.target.name]: e.target.value,
      });
      if (doorTypeName === "Other") {
        setDoorOtherFlag(true);
      } else {
        setDoorOtherFlag(false);
      }
    } else if (e.target.name === "doorConfiguration") {
      const doorConfigName = e.target.options[e.target.selectedIndex].text;
      setFormData({
        ...formData,
        doorConfigurationName: doorConfigName,
        [e.target.name]: e.target.value,
      });
      if (doorConfigName === "Double Door") {
        setIsDoubleDoor(true);
      } else {
        setIsDoubleDoor(false);
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    if (e.target.name === "doorColor") {
      e.target.value === "Other"
        ? setDoorColorOtherFlag(true)
        : setDoorColorOtherFlag(false);
    }
    if (e.target.name === "doorMaterial") {
      e.target.value === "Other"
        ? setDoorMaterialOtherFlag(true)
        : setDoorMaterialOtherFlag(false);
    }
    if (e.target.name === "GlazingDoor") {
      if (e.target.value === "Yes") {
        setIsGlazing(true);
        if (complianceCheck.pyroGlazing != BASE_MEASURES_COMP.pyroGlazing) {
          setActionMenuFlag({
            ...actionmenuFlag,
            pyroGlazing: true,
          });
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            pyroGlazing: false,
          });
        }
      } else {
        setIsGlazing(false);
        setActionMenuFlag({
          ...actionmenuFlag,
          pyroGlazing: false,
        });
      }
    }
  };

  const handleCancel = () => {
    // navigate(
    //   generatePath("/client/:clientNameParam/property-form", {
    //     clientNameParam,
    //   })
    // );
    const pathTemplate =
      "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyMasterId,
      inspectionRefnumber: inspectionRefnumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath, { replace: true });
    window.location.reload();
  };
  const handleFireResistanceChange = (e) => {
    resetIndvidualField("fireResistance");
    setFormData({
      ...formData,
      fireResistance: e.target.value,
    });
    if (!e.target.value.includes("S")) {
      //e.target.value === "FD30"
      if (isDoubleDoor) {
        const tempActionmenu = actionmenuFlag;
        if (
          formData.rightThreshold != null &&
          formData.rightThreshold != "" &&
          formData.rightThreshold > 8
        ) {
          tempActionmenu.rightThreshold = true;
          getAiSuggestion(
            "PHYSICAL",
            "rightThreshold",
            formData.rightThreshold,
          );
        } else {
          tempActionmenu.rightThreshold = false;
        }
        if (
          formData.leftThreshold != null &&
          formData.leftThreshold != "" &&
          formData.leftThreshold > 8
        ) {
          tempActionmenu.leftThreshold = true;
          getAiSuggestion("PHYSICAL", "leftThreshold", formData.leftThreshold);
        } else {
          tempActionmenu.leftThreshold = false;
        }
        setActionMenuFlag({ ...tempActionmenu });
      } else {
        if (
          formData.threshold != null &&
          formData.threshold != "" &&
          formData.threshold > 8
        ) {
          setActionMenuFlag({
            ...actionmenuFlag,
            threshold: true,
          });
          getAiSuggestion("PHYSICAL", "threshold", formData.threshold);
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            threshold: false,
          });
        }
      }
    } else {
      if (isDoubleDoor) {
        const tempActionmenu = actionmenuFlag;
        if (
          formData.leftThreshold != null &&
          formData.leftThreshold != "" &&
          formData.leftThreshold > BASE_MEASURES_DOUBLE.leftThreshold
        ) {
          tempActionmenu.leftThreshold = true;
          getAiSuggestion("PHYSICAL", "leftThreshold", formData.leftThreshold);
        } else {
          tempActionmenu.leftThreshold = false;
        }
        if (
          formData.rightThreshold != null &&
          formData.rightThreshold != "" &&
          formData.rightThreshold > BASE_MEASURES_DOUBLE.rightThreshold
        ) {
          tempActionmenu.rightThreshold = true;
          getAiSuggestion(
            "PHYSICAL",
            "rightThreshold",
            formData.rightThreshold,
          );
        } else {
          tempActionmenu.rightThreshold = false;
        }
        setActionMenuFlag({ ...tempActionmenu });
      } else {
        if (
          formData.threshold != null &&
          formData.threshold != "" &&
          formData.threshold > BASE_MEASURES_SINGLE.threshold
        ) {
          setActionMenuFlag({
            ...actionmenuFlag,
            threshold: true,
          });
          getAiSuggestion("PHYSICAL", "threshold", formData.threshold);
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            threshold: false,
          });
        }
      }
    }
    if (
      e.target.value === "FD30S" ||
      e.target.value === "FD60S" ||
      e.target.value === "FD90S"
    ) {
      setIsColdSeals(true);
    } else {
      setIsColdSeals(false);
    }
  };

  const handleGapsChange = (e) => {
    resetIndvidualField(e.target.name);
    setFormData({ ...formData, [e.target.name]: e.target.value });
    let baseMeasuresPhysical;
    if (isDoubleDoor) {
      baseMeasuresPhysical = BASE_MEASURES_DOUBLE;
    } else {
      baseMeasuresPhysical = BASE_MEASURES_SINGLE;
    }
    if (
      e.target.name === "threshold" ||
      e.target.name === "leftThreshold" ||
      e.target.name === "rightThreshold"
    ) {
      if (!formData.fireResistance.includes("S")) {
        //formData.fireResistance === "FD30"
        if (e.target.value > 8) {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: true,
          });
          getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: false,
          });
        }
      } else {
        if (e.target.value > baseMeasuresPhysical[e.target.name]) {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: true,
          });
          getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: false,
          });
        }
      }
    } else if (e.target.name === "noOfHinges") {
      if (
        e.target.value &&
        e.target.value < baseMeasuresPhysical[e.target.name]
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    } else {
      if (e.target.value > baseMeasuresPhysical[e.target.name]) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
        getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    }
  };

  const getSeverityDate = (sev) => {
    switch (sev.target.value) {
      case "Critical":
        return new Date().toISOString().split("T")[0];
      case "High":
        return new Date(new Date().setDate(new Date().getDate() + 30))
          .toISOString()
          .split("T")[0];
      case "Medium":
        return new Date(new Date().setDate(new Date().getDate() + 90))
          .toISOString()
          .split("T")[0];
      case "Low":
        return new Date(new Date().setDate(new Date().getDate() + 180))
          .toISOString()
          .split("T")[0];
      case "Select":
        return "";
      default:
        return new Date().toISOString().split("T")[0];
    }
  };

  const handleActionFieldsChange = (e, field, section) => {
    let name = e.target.name + field;
    resetIndvidualField(name);
    let value;
    let severityDueDate = "";
    if (field === "Severity") {
      severityDueDate = getSeverityDate(e);
      resetIndvidualField(e.target.name + "DueDate");
    }
    if (field === "Comments") {
      value = removeSpecialCharacters(e.target.value);
    } else {
      value = e.target.value;
    }
    if (field === "DamageType") {
      if (e.target.value === "Other") {
        setDamageTypeOtherFlag(true);
      } else {
        setDamageTypeOtherFlag(false);
      }
    }
    if (field === "Category") {
      if (e.target.value === "Door Replacement required") {
        if (section === "PHYSICAL") {
          setFormData({
            ...formData,
            [name]: value,
            [e.target.name + "Remediation"]:
              "Remediation - Fire Door Replacement required",
          });
        } else if (section === "COMPLIANCE") {
          setComplianceCheck({
            ...complianceCheck,
            [name]: value,
            [e.target.name + "Remediation"]:
              "Remediation - Fire Door Replacement required",
          });
        }
      } else {
        if (section === "PHYSICAL") {
          setFormData({
            ...formData,
            [name]: value,
            [e.target.name + "Remediation"]:
              formData[e.target.name + "Remediation"] ===
              "Remediation - Fire Door Replacement required"
                ? ""
                : formData[e.target.name + "Remediation"],
          });
        } else if (section === "COMPLIANCE") {
          setComplianceCheck({
            ...complianceCheck,
            [name]: value,
            [e.target.name + "Remediation"]:
              complianceCheck[e.target.name + "Remediation"] ===
              "Remediation - Fire Door Replacement required"
                ? ""
                : complianceCheck[e.target.name + "Remediation"],
          });
        }
      }
    } else {
      if (section === "PHYSICAL") {
        field === "Severity"
          ? setFormData({
              ...formData,
              [name]: value,
              [e.target.name + "DueDate"]: severityDueDate,
            })
          : setFormData({
              ...formData,
              [name]: value,
            });
      } else if (section === "COMPLIANCE") {
        field === "Severity"
          ? setComplianceCheck({
              ...complianceCheck,
              [name]: value,
              [e.target.name + "DueDate"]: severityDueDate,
            })
          : field === "Rating"
            ? setComplianceCheck({
                ...complianceCheck,
                [e.target.name + "Rating"]: value,
              })
            : setComplianceCheck({
                ...complianceCheck,
                [name]: value,
              });
      }
    }
  };
  const handleResetAction = (field, section) => {
    const Nme = [field] + "Timeline";
    const nme1 = [field] + "Severity";
    const nme2 = [field] + "Comments";
    const nme3 = [field] + "Category";
    const nme4 = [field] + "DueDate";
    const nme5 = [field] + "Remediation";
    const nme6 = [field] + "DamageType";
    const nme7 = [field] + "DamageTypeOther";
    if (section === "PHYSICAL") {
      setFormData({
        ...formData,
        [Nme]: "Select",
        [nme1]: "Select",
        [nme2]: "",
        [nme3]: "Select",
        [nme4]: "",
        [nme5]: "",
      });
    } else if (section === "COMPLIANCE") {
      setComplianceCheck({
        ...complianceCheck,
        [Nme]: "Select",
        [nme1]: "Select",
        [nme2]: "",
        [nme3]: "Select",
        [nme4]: "",
        [nme5]: "",
        [nme6]: "Select",
        [nme7]: "",
      });
    }
  };

  const base64ToBlob = (base64, contentType = "application/pdf") => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };

  const getFloorImage = async (floor) => {
    if (floor !== "" && !isNaN(floor)) {
      try {
        const response = await http.get(
          GET_FLOORPLAN_IMAGE +
            "propertyMasterID=" +
            propertyMasterId +
            "&floorNo=" +
            floor +
            "&inspectionReferenceNumber=" +
            inspectionRefnumber,
        );
        if (response?.status === 200) {
          const tempImage = response?.data;
          (tempImage.floorPlanImage === "" ||
            tempImage.floorPlanImage === null) &&
          (tempImage.floorPlanPdf === "" || tempImage.floorPlanPdf === null)
            ? setIsFloorFromAPI(false)
            : setIsFloorFromAPI(true);
          const ResponseMessage = tempImage?.message;
          const isFloorImage =
            tempImage.floorPlanImage != "" && tempImage.floorPlanImage != null;
          const isFloorPdf =
            tempImage.floorPlanPdf != "" && tempImage.floorPlanPdf != null;
          let pdfurl;
          if (isFloorPdf) {
            const blob = base64ToBlob(
              tempImage.floorPlanPdf,
              "application/pdf",
            );
            pdfurl =
              URL.createObjectURL(blob) +
              "?filename=" +
              (tempImage.floorPlanFileName || "floorplan.pdf");
            setFloorPlanPdfData(tempImage.floorPlanPdf);
          }
          setFloorPlanBlobUrl(tempImage.floorPlanImage);
          if (ResponseMessage === Messages.FLOOR_DOES_NOT_EXIST) {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: `Entered floor does not exist for this building.`,
            });
            setTimeout(() => {
              setBasicFormData({
                ...basicFormData,
                floor: "",
                floorPlan: [],
              });
            }, 1000);
          } else {
            setBasicFormData({
              ...basicFormData,
              floor: floor,
              floorPlan: isFloorPdf
                ? [pdfurl]
                : isFloorImage
                  ? [tempImage.floorPlanImage]
                  : [],
            });
          }
          tempImage.floorPlanImage === ""
            ? (mandatoryFieldRef.current.floorFile.value = "")
            : (mandatoryFieldRef.current.floorFile.value = "Saved Floor Plan");
          resetIndvidualField("floorFile");
        }
      } catch (error) {
        setError(error?.data);
        return {};
      }
    } else {
      setBasicFormData({
        ...basicFormData,
        floorPlan: [],
        floor: floor,
      });
      mandatoryFieldRef.current.floorFile.value = "";
    }
  };

  const [floorPlanImages, setFloorPlanImages] = useState([]);

  const handleChange = async (e) => {
    if (e.target.name === "floor") {
      resetIndvidualField(e.target.name);
      const { name, value } = e.target;
      if (value === "") {
        setBasicFormData({
          ...basicFormData,
          floorPlan: [],
          floor: value,
        });
        mandatoryFieldRef.current.floorFile.value = "";
        return;
      }
      let numericValue;
      //check if valid

      if (/^-?\d*\.?\d*$/.test(value)) {
        if (Number(value) >= -2) {
          numericValue = Number(value);
        } else {
          numericValue = -2;
        }
      }
      setBasicFormData({
        ...basicFormData,
        [name]: numericValue,
      });
      setTimeout(() => getFloorImage(numericValue), 100);
    } else if (e.target.name === "comment") {
      let val = removeSpecialCharacters(e.target.value);
      setBasicFormData({ ...basicFormData, comment: val });
    } else {
      const { name, value } = e.target;
      setBasicFormData({ ...basicFormData, [name]: value });
    }
  };

  const handleActionItemUpload = async (newImages, index, nameOfFile) => {
    const field = "customActionItem" + index;
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field, nameOfFile);
      if (uploadResult !== "") {
        newArr = [...newArr, uploadResult];
      } else {
        newArr = [...newArr];
      }
    } else {
      newArr = [];
    }

    setActionEntries((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item;

        const prevFieldValue = item.actionFile; // e.g., previous additionalDocsArr

        const updatedFile = [...prevFieldValue, ...newArr];

        return { ...item, actionFile: updatedFile };
      }),
    );
  };

  const handleImagesChange = async (newImages, field, nameOfFile) => {
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field, nameOfFile);
      if (uploadResult !== "") {
        newArr = [...newArr, uploadResult];
      } else {
        newArr = [...newArr];
        if (field === "Floor") {
          mandatoryFieldRef.current.floorFile.value = "";
        }
      }
    } else {
      newArr = [];
    }
    if (field === "Additional") {
      const combined = [...floorPlanImages, ...newArr];
      setFloorPlanImages(combined); // No limit now
    } else if (field === "Door") {
      mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
      const imgArr = formData.doorPhotos;
      const combined = [...imgArr, ...newArr];
      setFormData({
        ...formData,
        doorPhotos: combined,
      });
      resetIndvidualField("doorFile");
    } else if (field === "Floor") {
      mandatoryFieldRef.current.floorFile.style.border = "1px solid #dee2e6";
      const imgArr = basicFormData.floorPlan;
      const combined = [...imgArr, ...newArr];
      setBasicFormData({
        ...basicFormData,
        floorPlan: combined,
      });
      resetIndvidualField("floorFile");
    }
  };

  const handleImagesChangeMini = async (newImages, field, nameOfFile) => {
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field, nameOfFile);
      if (uploadResult !== "") {
        newArr = [...newArr, uploadResult];
      } else {
        newArr = [...newArr];
      }
    } else {
      newArr = [];
    }
    const imgArr = actionImages[field];
    const combined = [...imgArr, ...newArr];
    setActionImages({
      ...actionImages,
      [field]: combined,
    }); // No limit now
  };

  const generateQRCode = async () => {
    try {
      setShowModal(true);
      setShowLoader(true);
      let data =
        hostName +
        "/editSurvey/" +
        propertyMasterId +
        "/" +
        inspectionRefnumber +
        "/" +
        formData.doorNumber;

      // const qrCodeUrl = await http.get(GENERATEQRCODE_API + data);
      const qrCodeUrl = await http.get(GENERATEQRCODE_API + data, {
        params: {
          loggedInUserId: userObj.userId,
          clientSubdomainName: clientNameParam,
        },
      });
      setQrCode(qrCodeUrl.data.qrCode);
      setShowLoader(false);
    } catch (error) {
      throw new Error(`HTTP error! status: ${error}`);
    } finally {
      setShowLoader(false);
    }
    setShowModal(true);
  };

  const removeSpecialCharacters = (input) => {
    return input.replace(/[^a-zA-Z0-9 !?.,"'() & :; -]/g, ""); // Keeps letters, numbers, and spaces
  };

  const handleFormReset = () => {
    setFormData((prev) => ({
      ...prev,

      // General
      doorLocation: "",
      doorType: "1",
      doorColor: "Select",
      doorColorOther: "",
      doorMaterial: "Select",
      doorMaterialOther: "",
      GlazingDoor: "Select",
      doorOther: "",
      doorPhotos: [],
      fireResistance: "Select",
      doorConfiguration: "Select",
      doorConfigurationName: "",

      // PHYSICAL MEASUREMENTS - GAPS
      head: "",
      headTimeline: "Select",
      headSeverity: "Select",
      headComments: "",
      headCategory: "Select",
      headDueDate: "",
      headRemediation: "",

      hinge: "",
      hingeLocation: "Select",
      noOfHinges: "",
      noOfHingesTimeline: "Select",
      noOfHingesSeverity: "Select",
      noOfHingesComments: "",
      noOfHingesCategory: "Select",
      noOfHingesDueDate: "",
      noOfHingesRemediation: "",
      hingeTimeline: "Select",
      hingeSeverity: "Select",
      hingeComments: "",
      hingeCategory: "Select",
      hingeDueDate: "",
      hingeRemediation: "",

      closing: "",
      closingTimeline: "Select",
      closingSeverity: "Select",
      closingComments: "",
      closingCategory: "Select",
      closingDueDate: "",
      closingRemediation: "",

      threshold: "",
      thresholdTimeline: "Select",
      thresholdSeverity: "Select",
      thresholdComments: "",
      thresholdCategory: "Select",
      thresholdDueDate: "",
      thresholdRemediation: "",

      doorThickness: "",
      frameDepth: "",
      doorHeight: "",
      doorWidth: "",
      fullDoorsetSize: "",

      leftHead: "",
      leftHeadTimeline: "Select",
      leftHeadSeverity: "Select",
      leftHeadComments: "",
      leftHeadCategory: "Select",
      leftHeadDueDate: "",
      leftHeadRemediation: "",
      rightHead: "",
      rightHeadTimeline: "Select",
      rightHeadSeverity: "Select",
      rightHeadComments: "",
      rightHeadCategory: "Select",
      rightHeadDueDate: "",
      rightHeadRemediation: "",

      leftHinge: "",
      leftHingeTimeline: "Select",
      leftHingeSeverity: "Select",
      leftHingeComments: "",
      leftHingeCategory: "Select",
      leftHingeDueDate: "",
      leftHingeRemediation: "",
      rightHinge: "",
      rightHingeTimeline: "Select",
      rightHingeSeverity: "Select",
      rightHingeComments: "",
      rightHingeCategory: "Select",
      rightHingeDueDate: "",
      rightHingeRemediation: "",

      leftThreshold: "",
      leftThresholdTimeline: "Select",
      leftThresholdSeverity: "Select",
      leftThresholdComments: "",
      leftThresholdCategory: "Select",
      leftThresholdDueDate: "",
      leftThresholdRemediation: "",
      rightThreshold: "",
      rightThresholdTimeline: "Select",
      rightThresholdSeverity: "Select",
      rightThresholdComments: "",
      rightThresholdCategory: "Select",
      rightThresholdDueDate: "",
      rightThresholdRemediation: "",
    }));

    // Basic info reset
    setBasicFormData((prev) => ({
      ...prev,
      date: new Date().toISOString().split("T")[0],
      floor: "",
      comment: "",
      floorPlan: [],
    }));

    // Other resets
    setFloorPlanImages([]);

    setComplianceCheck((prev) => ({
      ...prev,
      intumescentStrips: true,
      intumescentStripsTimeline: "Select",
      intumescentStripsSeverity: "Select",
      intumescentStripsComments: "",
      intumescentStripsCategory: "Select",
      intumescentStripsDueDate: "",
      intumescentStripsRemediation: "",
      coldSmokeSeals: true,
      coldSmokeSealsTimeline: "Select",
      coldSmokeSealsSeverity: "Select",
      coldSmokeSealsComments: "",
      coldSmokeSealsCategory: "Select",
      coldSmokeSealsDueDate: "",
      coldSmokeSealsRemediation: "",
      selfClosingDevice: true,
      selfClosingDeviceTimeline: "Select",
      selfClosingDeviceSeverity: "Select",
      selfClosingDeviceComments: "",
      selfClosingDeviceCategory: "Select",
      selfClosingDeviceDueDate: "",
      selfClosingDeviceRemediation: "",
      fireLockedSign: true,
      fireLockedSignTimeline: "Select",
      fireLockedSignSeverity: "Select",
      fireLockedSignComments: "",
      fireLockedSignCategory: "Select",
      fireLockedSignDueDate: "",
      fireLockedSignRemediation: "",
      fireShutSign: true,
      fireShutSignTimeline: "Select",
      fireShutSignSeverity: "Select",
      fireShutSignComments: "",
      fireShutSignCategory: "Select",
      fireShutSignDueDate: "",
      fireShutSignRemediation: "",
      holdOpenDevice: true,
      visibleCertification: true,
      doorGlazing: true,
      pyroGlazing: true,
      pyroGlazingTimeline: "Select",
      pyroGlazingSeverity: "Select",
      pyroGlazingComments: "",
      pyroGlazingCategory: "Select",
      pyroGlazingDueDate: "",
      pyroGlazingRemediation: "",
      doorCloseFully: true,
      doorCloseFullyTimeline: "Select",
      doorCloseFullySeverity: "Select",
      doorCloseFullyComments: "",
      doorCloseFullyCategory: "Select",
      doorCloseFullyDueDate: "",
      doorCloseFullyRemediation: "",
      damageToDoor: false,
      damageToDoorTimeline: "Select",
      damageToDoorSeverity: "Select",
      damageToDoorComments: "",
      damageToDoorCategory: "Select",
      damageToDoorDueDate: "",
      damageToDoorRemediation: "",
      visualDefectsToDoor: false,
      visualDefectsToDoorTimeline: "Select",
      visualDefectsToDoorSeverity: "Select",
      visualDefectsToDoorComments: "",
      visualDefectsToDoorCategory: "Select",
      visualDefectsToDoorDueDate: "",
      visualDefectsToDoorRemediation: "",
      visualDefectsToDoorDamageType: "Select",
      visualDefectsToDoorDamageTypeOther: "",
      hingesFireRated: true,
      hingesFireRatedTimeline: "Select",
      hingesFireRatedSeverity: "Select",
      hingesFireRatedComments: "",
      hingesFireRatedCategory: "Select",
      hingesFireRatedDueDate: "",
      hingesFireRatedRemediation: "",
      hingesFireRatedRating: "Select",
      doorFitWithinFrame: true,
      doorFitWithinFrameTimeline: "Select",
      doorFitWithinFrameSeverity: "Select",
      doorFitWithinFrameComments: "",
      doorFitWithinFrameCategory: "Select",
      doorFitWithinFrameDueDate: "",
      doorFitWithinFrameRemediation: "",
      doorFitWithinFrameRating: "Select",
      damageToFrame: false,
      damageToFrameTimeline: "Select",
      damageToFrameSeverity: "Select",
      damageToFrameComments: "",
      damageToFrameCategory: "Select",
      damageToFrameDueDate: "",
      damageToFrameRemediation: "",
      damageToFrameRating: "Select",
    }));
    setActionMenuFlag((prev) => ({
      ...prev,
      head: false,
      hinge: false,
      closing: false,
      threshold: false,
      noOfHinges: false,
      intumescentStrips: false,
      coldSmokeSeals: false,
      selfClosingDevice: false,
      fireLockedSign: false,
      fireShutSign: false,
      pyroGlazing: false,
      doorCloseFully: false,
      damageToDoor: false,
      visualDefectsToDoor: false,
      hingesFireRated: false,
      doorFitWithinFrame: false,
      damageToFrame: false,
      leftHead: false,
      rightHead: false,
      leftHinge: false,
      rightHinge: false,
      leftThreshold: false,
      rightThreshold: false,
    }));
    setActionImages((prev) => ({
      ...prev,
      head: [],
      hinge: [],
      closing: [],
      threshold: [],
      noOfHinges: [],
      intumescentStrips: [],
      coldSmokeSeals: [],
      selfClosingDevice: [],
      fireLockedSign: [],
      fireShutSign: [],
      pyroGlazing: [],
      doorCloseFully: [],
      damageToDoor: [],
      visualDefectsToDoor: [],
      hingesFireRated: [],
      doorFitWithinFrame: [],
      damageToFrame: [],
      leftHead: [],
      rightHead: [],
      leftHinge: [],
      rightHinge: [],
      leftThreshold: [],
      rightThreshold: [],
    }));
    setDoorOtherFlag(false);
    setDoorColorOtherFlag(false);
    setDoorMaterialOtherFlag(false);
    setIsDoubleDoor(false);
    // complianceCheck.doorGlazing ? setIsGlazing(true) : setIsGlazing(false);
    setValidationFlag({ show: false, message: "" });
    setIsColdSeals(false);
    setFireKeepLocked(false);
    setIsGlazing(false);
    setIsHoldopenVisible(false);
    setQrCode("");

    // MiniCapture reset flag
    setResetCaptureFlag(true);
    setTimeout(() => setResetCaptureFlag(false), 100);
    //red highlights reset
    setTimeout(() => resetMandatoryFields(), setActionEntries([]), 100);
  };

  const getAiSuggestion = async (type, name, value) => {
    if (isAIIntegrated) {
      setIsloading(true);
      try {
        const payload = {
          email: userObj?.userEmail,
          inspectionReferenceNumber: inspectionRefnumber,
          doorReferenceNumber: formData?.doorNumber,
          measurementType: aiSuggestionData[name + "Title"],
          value: value,
          unit: aiSuggestionData[name + "Unit"],
          apiKey: "claude_key",
          aiProvider: "claude",
        };
        const response = await http.post(GET_AI_SUGGESTION, payload);
        if (response.status === 200) {
          const ai_data = JSON.parse(response?.data?.response);
          const ref = response?.data?.referenceNum;
          setAiSuggestionData({
            ...aiSuggestionData,
            [name + "Action"]: ai_data?.actionItems[0],
            [name + "refRemediation"]: ai_data?.referenceRemediation,
            [name + "RefNo"]: ref,
            [name + "Type"]: type,
          });
          const seveValue =
            ai_data?.actionItems[0]?.severity.charAt(0).toUpperCase() +
            ai_data?.actionItems[0]?.severity.slice(1).toLowerCase();
          setShowAiSuggestionModal({
            show: true,
            heading: name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(),
            title: name,
            desctription: ai_data?.actionItems[0]?.actionDescription,
            severity: seveValue,
            category: ai_data?.actionItems[0]?.category,
            dueDate: ai_data?.actionItems[0]?.dueDate,
            remedyOptions: ai_data?.actionItems[0]?.remediationOptions,
            remediationValue:
              ai_data?.referenceRemediation?.inspectorGuidance || "",
            confScore: ai_data?.actionItems[0]?.confidenceScore,
            rejectReason: "",
          });
          setIsloading(false);
        }
      } catch (error) {
        setIsloading(false);
        // Errors during AI suggestion fetch are handled by the loading indicator state.
      }
    }
  };

  const handleRejectAISuggest = async (title, reject) => {
    setShowAiSuggestionModal({
      show: false,
      title: "",
      heading: "",
      desctription: "",
      severity: "",
      dueDate: "",
      remedyOptions: [],
      remediationValue: "",
      confScore: "",
      category: "",
      rejectReason: "",
    });
    setRejectionReason(false);
    setSelectedRemediation({
      ...selectedRemediation,
      [title]: null,
    });
    try {
      const payload = {
        refNo: aiSuggestionData[title + "RefNo"],
        rejectedComment: reject,
        isAccept: false,
        acceptedResponse: "",
      };
      await http.post(SEND_FEEDBACK_TO_AI, payload);
    } catch (error) {
      // Ignore AI feedback errors for reject action; user flow continues.
    }
  };

  const handleAcceptAISuggest = async (title) => {
    setShowAiSuggestionModal({
      show: false,
      title: "",
      heading: "",
      desctription: "",
      severity: "",
      dueDate: "",
      remedyOptions: [],
      remediationValue: "",
      confScore: "",
      category: "",
    });
    setRejectionReason(false);
    let selectedReme = selectedRemediation;
    const severityValues = [
      { option: "Critical", value: "Critical" },
      { option: "High", value: "High" },
      { option: "Medium", value: "Medium" },
      { option: "Low", value: "Low" },
    ];
    const categoryValues = [
      { option: "Firedoor Repair", value: "Fire door Repair" },
      { option: "Signage repair", value: "Signage repair" },
      { option: "Fire door Replacement", value: "Fire door Replacement" },
      {
        option: "Testing, Records, Log Book",
        value: "Testing, Records, Log Book",
      },
      {
        option: "Door Replacement required",
        value: "Door Replacement required",
      },
      { option: "Door Repair", value: "Door Repair" },
    ];
    const actionitemSelected = aiSuggestionData[title + "Action"];
    const formattedSev = severityValues.filter(
      (x) =>
        x.option.toLowerCase() === actionitemSelected.severity.toLowerCase(),
    )[0].value;
    const tempCategory = categoryValues.filter(
      (x) =>
        x.option.toLowerCase() === actionitemSelected.category.toLowerCase(),
    )[0].value;
    //const formattedSev = actionitemSelected.severity.charAt(0).toUpperCase() + actionitemSelected.severity.slice(1).toLowerCase();
    // Split and reorder to ISO format
    const [day, month, year] = actionitemSelected.dueDate.split("/");
    const isoDate = `${year}-${month}-${day}`;

    // Now safely parse
    const formDate = new Date(isoDate).toISOString().split("T")[0];
    const remedyOption =
      actionitemSelected.remediationOptions[selectedReme[title]];
    const type = aiSuggestionData[title + "Type"];
    if (type === "PHYSICAL") {
      setFormData({
        ...formData,
        [title + "Severity"]: formattedSev,
        [title + "DueDate"]: formDate,
        [title + "Category"]: tempCategory,
        // [title + "Remediation"]:
        //   remedyOption.option.replace(/^Option\s\d+:\s*/, "") +
        //   ": " +
        //   remedyOption.plan,
        [title + "Remediation"]:
          aiSuggestionData[title + "refRemediation"]?.inspectorGuidance || "",
      });
    } else if (type === "COMPLIANCE") {
      setComplianceCheck({
        ...complianceCheck,
        [title + "Severity"]: formattedSev,
        [title + "DueDate"]: formDate,
        [title + "Category"]: tempCategory,
        // [title + "Remediation"]:
        //   remedyOption.option.replace(/^Option\s\d+:\s*/, "") +
        //   ": " +
        //   remedyOption.plan,
        [title + "Remediation"]:
          aiSuggestionData[title + "refRemediation"]?.inspectorGuidance || "",
      });
    }
    setSelectedRemediation({
      ...selectedRemediation,
      [title]: null,
    });
    try {
      // const params = new URLSearchParams();
      // params.append("RefNo", aiSuggestionData[title + "RefNo"]);
      // params.append("IsAccept", true);
      // const query = params.toString();
      const payload = {
        refNo: aiSuggestionData[title + "RefNo"],
        rejectedComment: "",
        isAccept: true,
        acceptedResponse: remedyOption.option,
      };
      await http.post(SEND_FEEDBACK_TO_AI, payload);
    } catch (error) {
      // Feedback failures are intentionally ignored here; no user action required.
    }
  };

  const { userObj } = useSelector((state) => state.user);
  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link
              to={generatePath("/client/:clientNameParam/", {
                clientNameParam,
              })}
            >
              Go back to Login
            </Link>
          </div>
        </div>
      </>
    );
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={() => {
              closeButton();
            }}
          />
          <ConfirmationPopup
            show={showConfirmationPopup.show}
            headingText={showConfirmationPopup.headingText}
            infoText={showConfirmationPopup.infoText}
            cancelText={showConfirmationPopup.cancelText}
            submitText={showConfirmationPopup.submittext}
            onCancel={() => {
              setShowConfirmationPopup({
                ...showConfirmationPopup,
                show: false,
                headingText: "",
                infoText: "",
                cancelText: "",
                submittext: "",
              });
            }}
            onSubmit={() => {
              setShowConfirmationPopup({
                ...showConfirmationPopup,
                show: false,
                headingText: "",
                infoText: "",
                cancelText: "",
                submittext: "",
              });
              handleValidationOnSave("In Progress");
            }}
          />
          {/* <Loader active={isLoading} /> */}
          <LoadingComponent loading={isLoading} />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}

          {showModal && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "60%" }}
              >
                <span
                  className="close"
                  style={{ top: "0px" }}
                  onClick={() => setShowModal(false)}
                >
                  &times;
                </span>
                <h6 className="modal-header">
                  {formData.buildingName} / {formData.doorNumber}
                </h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  {showLoader ? (
                    <div
                      className="approvalLoader"
                      style={{ marginLeft: "45%" }}
                    ></div>
                  ) : (
                    qrCode && (
                      <img
                        src={qrCode}
                        alt="QR Code"
                        style={{ height: "80%", width: "50%" }}
                      />
                    )
                  )}
                  {!showLoader && (
                    <div style={{ marginTop: "20px" }}>
                      <button
                        className="btn btn-primary"
                        style={{ minHeight: "20px" }}
                        onClick={handlePrint}
                      >
                        Print
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {showAiSuggestionModal.show && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "70%" }}
              >
                {/* <span
                  className="close"
                  onClick={() => setShowAiSuggestionModal(false)}
                >
                  &times;
                </span> */}
                <h6 className="modal-header">
                  AI Based Suggestion - Action item for{" "}
                  {showAiSuggestionModal.heading}
                </h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="px-2 py-1">
                    <div className="d-flex flex-row justify-content-between">
                      <p className="ai-header">Action Description:</p>{" "}
                      <p className="ai-header-confidence">
                        Confidence Score:{" "}
                        <span
                          style={
                            Number(showAiSuggestionModal.confScore) >= 90
                              ? { color: "#00A600" }
                              : { color: "#CB8300" }
                          }
                        >
                          {showAiSuggestionModal.confScore}%
                        </span>
                      </p>
                    </div>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.desctription}
                    </p>
                    <p className="ai-header">Severity:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.severity}
                    </p>
                    <p className="ai-header">Due Date:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.dueDate}
                    </p>
                    <p className="ai-header">Category:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.category}
                    </p>
                    {/* <p className="ai-header">Remediation Options:</p> html below */}

                    <p className="ai-header">Remediation:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.remediationValue}
                    </p>
                    <div className="ai-disclaimer">
                      <p className="mb-0">
                        <i className="bi bi-exclamation-triangle text-danger"></i>{" "}
                        AI Disclaimer
                      </p>
                      <p>
                        The results displayed above are generated using
                        Artificial Intelligence (AI) and may not always be fully
                        accurate or complete. AI-generated results are for
                        <strong> guidance only</strong> and may not reflect full
                        inspection accuracy.{" "}
                        <strong>
                          Please verify all findings manually before taking
                          compliance action.
                        </strong>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-1">
                    <button
                      className="btn btn-secondary"
                      style={{ minHeight: "20px" }}
                      onClick={() => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          show: false,
                        });
                        setRejectionReason(true);
                      }}
                    >
                      Reject
                    </button>
                    <button
                      className="btn btn-primary"
                      style={{ minHeight: "20px" }}
                      // disabled={
                      //   selectedRemediation[showAiSuggestionModal.title] ===
                      //   null
                      // }
                      onClick={() =>
                        handleAcceptAISuggest(showAiSuggestionModal.title)
                      }
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {rejectionReason && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "60%" }}
              >
                {/* <span className="close" onClick={() => setShowModal(false)}>
                  &times;
                </span> */}
                <h6 className="modal-header">Reject AI Based Suggestion</h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="px-2 py-1">
                    <p className="ai-paragraph">
                      If you believe the AI analysis needs correction, please
                      share your feedback below.
                    </p>
                    <textarea
                      className="form-control"
                      rows="4"
                      style={{ minHeight: "auto", height: "auto" }}
                      placeholder=""
                      value={showAiSuggestionModal.rejectReason}
                      onChange={(e) => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          rejectReason: e.target.value,
                        });
                      }}
                      id="floatingTextarea"
                    ></textarea>
                  </div>
                  <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-1">
                    <button
                      className="btn btn-secondary"
                      style={{ minHeight: "20px" }}
                      onClick={() => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          show: true,
                        });
                        setRejectionReason(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      style={{ minHeight: "20px" }}
                      disabled={showAiSuggestionModal.rejectReason === ""}
                      onClick={() =>
                        handleRejectAISuggest(
                          showAiSuggestionModal.title,
                          showAiSuggestionModal.rejectReason,
                        )
                      }
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            className="d-flex dashboard_body flex-column py-3 "
            style={{ overflow: "auto" }}
          >
            <form className="row m-0">
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                <BasicInformationSection
                  mandatoryFieldRef={mandatoryFieldRef}
                  basicFormData={basicFormData}
                  handleChange={handleChange}
                  handleBuildingName={handleBuildingName}
                  isView={false}
                  formData={formData}
                  handleImagesChange={handleImagesChange}
                  handleDeleteImages={handleDeleteImages}
                  resetCaptureFlag={resetCaptureFlag}
                  handleFormDataChange={handleFormDataChange}
                  doorTypesOption={doorTypesOption}
                  doorOtherFlag={doorOtherFlag}
                  ShowScanQRCode={ShowScanQRCode}
                  generateQRCode={generateQRCode}
                  OnsetShowScanQRCode={setShowScanQRCode}
                  qrCode={qrCode}
                  setShowModal={setShowModal}
                  doorColorOtherFlag={doorColorOtherFlag}
                  doorMaterialOtherFlag={doorMaterialOtherFlag}
                  doorConfigurationsOption={doorConfigurationsOption}
                />
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">
                        Fire Rating and certification
                        <span style={{ color: "red" }}>*</span>
                      </p>
                    </div>
                    <div className="form-floating">
                      <select
                        ref={(el) =>
                          (mandatoryFieldRef.current.fireResistance = el)
                        }
                        className="form-select"
                        name="fireResistance"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={formData.fireResistance}
                        onChange={handleFireResistanceChange}
                      >
                        <option selected>Select</option>
                        <option value="FD30">FD30</option>
                        <option value="FD60">FD60</option>
                        <option value="FD90">FD90</option>
                        <option value="FD120">FD120</option>
                        <option value="FD30S">FD30S</option>
                        <option value="FD60S">FD60S</option>
                        <option value="FD90S">FD90S</option>
                        <option value="FD120S">FD120S</option>
                      </select>
                      <label htmlFor="floatingSelect">
                        Fire Resistance<span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="card mb-4">
                  <PhyMeasurementsSection
                    isRequestForChange={false}
                    isApprover={false}
                    isAppprovalPending={false}
                    handleApproverComments={() => {}}
                    handleApproverCheckbox={() => {}}
                    approverComments={[]}
                    approverCheckbox={[]}
                    formData={formData}
                    mandatoryFieldRef={mandatoryFieldRef}
                    handleDeleteImages={handleDeleteImages}
                    reset={resetCaptureFlag}
                    handleFormDataChange={handleFormDataChange}
                    isView={false}
                    handleGapsChange={handleGapsChange}
                    actionmenuFlag={actionmenuFlag}
                    actionImages={actionImages}
                    handleImagesChangeMini={handleImagesChangeMini}
                    handleResetAction={handleResetAction}
                    handleActionFieldsChange={handleActionFieldsChange}
                    isDoubleDoor={isDoubleDoor}
                  />
                </div>

                <div className="card">
                  <AdditionalActionItems
                    actionEntries={actionEntries}
                    setActionEntries={setActionEntries}
                    actionFieldsRef={actionFieldsRef}
                    isView={false}
                    onDeleteImage={(image) => deleteImageAPI(image)}
                    onUploadImage={(image, index, nameOfFile) =>
                      handleActionItemUpload(image, index, nameOfFile)
                    }
                    actionErrors={actionErrors}
                    setActionErrors={setActionErrors}
                    reset={resetCaptureFlag}
                    sRequestForChange={false}
                    isApprover={false}
                    isAppprovalPending={false}
                    handleApproverComments={() => {}}
                    handleApproverCheckbox={() => {}}
                    approverComments={[]}
                    approverCheckbox={[]}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-lg-4 mb-3">
                <div className="card mb-4">
                  <ComplianceSection
                    isRequestForChange={false}
                    isApprover={false}
                    isAppprovalPending={false}
                    handleApproverComments={() => {}}
                    handleApproverCheckbox={() => {}}
                    approverComments={[]}
                    approverCheckbox={[]}
                    mandatoryFieldRef={mandatoryFieldRef}
                    complianceCheck={complianceCheck}
                    handleComplianceToggle={handleComplianceToggle}
                    isColdSeals={isColdSeals}
                    isHoldOpenVisible={isHoldOpenVisible}
                    isFireKeepLocked={isFireKeepLocked}
                    isGlazing={isGlazing}
                    handleDeleteImages={handleDeleteImages}
                    resetCaptureFlag={resetCaptureFlag}
                    isView={false}
                    actionmenuFlag={actionmenuFlag}
                    actionImages={actionImages}
                    handleImagesChangeMini={handleImagesChangeMini}
                    handleResetAction={handleResetAction}
                    handleActionFieldsChange={handleActionFieldsChange}
                  />
                </div>
                <div className="card mb-4 additionalInfo">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">
                        Additional Photos{" "}
                        <i
                          className="bi bi-info-circle"
                          style={{
                            fontSize: "0.9rem",
                            marginTop: "-7px",
                            marginLeft: "5px",
                          }}
                          title={`Please upload at least ${Number(companyMandatoryImages) - 1} additional images.`}
                        ></i>
                      </p>
                    </div>
                    <div className="form-floating">
                      <div className="col-sm-12 mb-3">
                        <div className="d-flex gap-3 flex-wrap">
                          <Capture
                            onImagesChange={(images, nameOfFile) =>
                              handleImagesChange(
                                images,
                                "Additional",
                                nameOfFile,
                              )
                            }
                            onImageDelete={(index) =>
                              handleDeleteImages(index, "Additional")
                            }
                            reset={resetCaptureFlag}
                            mandatoryFieldRef={mandatoryFieldRef}
                            fieldValue={"additionalFile"}
                            allowPdf={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-4 additionalInfo">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">Additional Comments</p>
                    </div>
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        rows="5"
                        style={{ minHeight: "auto", height: "auto" }}
                        placeholder="Comments"
                        // value="Comments"
                        id="floatingTextarea"
                        name="comment"
                        value={basicFormData.comment}
                        onChange={(e) => handleChange(e)}
                      ></textarea>
                      <label htmlFor="floatingTextarea">Comments</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mb-3">
                <div className="card">
                  {validationFlag?.show && (
                    <span style={{ color: "red" }}>
                      {validationFlag?.message}
                    </span>
                  )}
                  <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                    <button
                      type="button"
                      className="btn btn-tertiary"
                      onClick={() => {
                        handleCancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => handleFormReset()}
                    >
                      Reset
                    </button>
                    <button
                      type="button"
                      disabled={isLoading}
                      className="btn btn-primary"
                      onClick={() =>
                        setShowConfirmationPopup({
                          ...showConfirmationPopup,
                          show: true,
                          headingText: "Save and Proceed",
                          infoText:
                            "Please make sure you have filled all correct details, once submitted, you may edit the survey through the Compliance Summary Screen",
                          cancelText: "Cancel",
                          submittext: "Submit",
                        })
                      }
                    >
                      Save & Proceed
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <Footer />
            <div className="bottom-bar-spacing"></div>
            <BottomBarIcons />
          </div>
        </div>
      )}
    </>
  );
};
export default Dashboard;
